module.exports = __webpack_public_path__ + "static/media/23PerformancePhotos.17ca266f.jpeg";